import { Typography } from '@mui/material';
import React from 'react';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const ReferenceCell = React.memo((row: OrderWorkunit) => (
  <Typography noWrap variant="body2">
    {row.workunit_reference ?? ''}
  </Typography>
));

export default ReferenceCell;
